import script from "./CardActivityLog.vue?vue&type=script&setup=true&lang=js"
export * from "./CardActivityLog.vue?vue&type=script&setup=true&lang=js"

import "./CardActivityLog.vue?vue&type=style&index=0&id=60daed67&lang=css"

const __exports__ = script;

export default __exports__